import React from "react"
import CustomCard from "components/Atoms/CustomCard"
import { useNavigate } from "react-router-dom"
import CustomButton from "../Atoms/CustomButton"

export interface FormLayoutProps {
  /**
   * The primary key of the resource
   * eg. 3820 if the resource is already present, else
   * could either be null or undefined in case of a new resource
   */
  id?: number | string | null | undefined
  /**
   * The type of the resource, usually denotes the title
   * eg. Vehicle,User..etc
   */
  type: string

  className?: string
  children?: React.ReactNode
}
const FormLayout = ({ id, children, type, className }: FormLayoutProps) => {
  const navigate = useNavigate()
  return (
    <CustomCard className={className}>
      <div className="mt-2 w-full flex items-center">
        <span>
          <CustomButton
            icon="arrow-left"
            onClick={() => navigate(-1)}
            minimal={true}
          ></CustomButton>
        </span>
        <h5 className="ml-3">
          {id ? "Edit" : "New"} {type}
        </h5>
      </div>
      <div className="container mt-3">{children}</div>
    </CustomCard>
  )
}

export default FormLayout
